const initialState = { 
  loading: false,
  success: null,
  error: null
}

function deleteVoucherReducer(state = initialState, action) {
  switch (action.type) {
    case 'DELETE_VOUCHER_BEGIN':
      return {
        ...state,
        loading: true,
        success: null,
        error: null
      }

    case 'DELETE_VOUCHER_SUCCESS':
      return {
        ...state,
        loading: false,
        success: action.success
      }

    case 'DELETE_VOUCHER_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default: return state
  }
}

export default deleteVoucherReducer